import MuiModal from '@mui/material/Modal';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import React from 'react';
import { ButtonFlatMedium, ButtonPrimaryMedium } from '../Buttons';
import { BodyLargeEmphasized } from '../Typography';
import styles from './Modal.styles';
import { AccessibleDivButton } from '@/components';
import { cx } from '@emotion/css';

interface Props {
  title: string;
  isOpen: boolean;
  children?: React.ReactNode;
  cancelButtonText?: string;
  confirmButtonText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  onClose: () => void;
  disableCancelButton?: boolean;
  disableConfirmButton?: boolean;
  loading?: boolean;
  className?: string;
}

export const Modal: React.FC<Props> = ({
  title,
  children,
  isOpen,
  cancelButtonText = 'Cancel',
  confirmButtonText = 'Confirm',
  onConfirm,
  onCancel,
  onClose,
  className,
  disableCancelButton = false,
  disableConfirmButton = false,
  loading = false,
}) => {
  return (
    <MuiModal open={isOpen} onClose={onClose}>
      <div className={cx(styles.container, className)}>
        <div className={styles.modalTitleContainer}>
          <AccessibleDivButton className={styles.closeButton} onClick={onClose}>
            <CloseOutlinedIcon />
          </AccessibleDivButton>
          <BodyLargeEmphasized className={styles.title}>{title}</BodyLargeEmphasized>
        </div>
        <div className={styles.content}>{children}</div>
        <div className={styles.footer}>
          <ButtonFlatMedium onClick={onCancel} disabled={disableCancelButton}>
            {cancelButtonText}
          </ButtonFlatMedium>
          <ButtonPrimaryMedium
            onClick={onConfirm}
            disabled={disableConfirmButton}
            loading={loading}
            nonTranslate
          >
            {confirmButtonText}
          </ButtonPrimaryMedium>
        </div>
      </div>
    </MuiModal>
  );
};
